<template>
  <div class="khata-card">
    <h2>KhataKharch Settings</h2>
    <form @submit.prevent="saveSettings">
      <div class="khata-grid">
        <label>
          <span>Master Salary</span>
          <input type="number" v-model.number="fields.masterSalary" />
        </label>
        <label>
          <span>Bim Gator</span>
          <input type="number" v-model.number="fields.bimGator" />
        </label>
        <label>
          <span>Karigar</span>
          <input type="number" v-model.number="fields.karigar6" />
        </label>
        <label>
          <span>Bhadu</span>
          <input type="number" v-model.number="fields.bhadu" />
        </label>
        <label>
          <span>Safsafai</span>
          <input type="number" v-model.number="fields.safsafai" />
        </label>
        <label>
          <span>Helper</span>
          <input type="number" v-model.number="fields.helper" />
        </label>
        <label>
          <span>Droppin</span>
          <input type="number" v-model.number="fields.droppin" />
        </label>
        <label>
          <span>BIM Pasaramni</span>
          <input type="number" v-model.number="fields.bimPasaramni" />
        </label>
        <label>
          <span>Mending Folding</span>
          <input type="number" v-model.number="fields.mendingFolding" />
        </label>
        <label>
          <span>Light</span>
          <input type="number" v-model.number="fields.light" />
        </label>
        <label>
          <span>Air Compressor Maintance</span>
          <input type="number" v-model.number="fields.airCompressorMaintance" />
        </label>
        <label>
          <span>Machine Maintance</span>
          <input type="number" v-model.number="fields.machineMaintance" />
        </label>
        <label>
          <span>Tampo Bhadu</span>
          <input type="number" v-model.number="fields.tampoBhadu" />
        </label>
        <label>
          <span>Loan Installement</span>
          <input type="number" v-model.number="fields.loanInstallement" />
        </label>
        <label>
          <span>Owner Salary</span>
          <input type="number" v-model.number="fields.ownerSalary" />
        </label>
        <label>
          <span>Number Of Machines</span>
          <input type="number" v-model.number="fields.machines" />
        </label>
      </div>
      <div style="text-align:center; margin-top:18px;">
        <button type="submit" class="save-btn">💾 Save Settings</button>
      </div>
      <div v-if="saved" class="saved-msg">Settings saved!</div>
    </form>
  </div>
</template>

<script>
const STORAGE_KEY = 'khataKharchSettings';

export default {
  name: 'KhataKharchSettings',
  data() {
    return {
      fields: {
        masterSalary: 0,
        bimGator: 0,
        karigar6: 0,
        bhadu: 0,
        safsafai: 0,
        helper: 0,
        droppin: 0,
        bimPasaramni: 0,
        mendingFolding: 0,
        light: 0,
        airCompressorMaintance: 0,
        machineMaintance: 0,
        tampoBhadu: 0,
        loanInstallement: 0,
        ownerSalary: 0,
        machines: 0
      },
      saved: false
    };
  },
  mounted() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      this.fields = JSON.parse(saved);
    }
  },
  methods: {
    saveSettings() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.fields));
      this.saved = true;
      setTimeout(() => (this.saved = false), 1200);
    }
  }
};
</script>

<style scoped>
.khata-card {
  max-width: 480px;
  margin: 32px auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 18px 18px 28px 18px;
}
h2 {
  text-align: center;
  color: #2563eb;
  font-size: 1.2rem;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}
.khata-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 18px;
}
label {
  font-size: 13px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
input[type="number"] {
  width: 100%;
  padding: 4px 7px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  background: #f8fafc;
  transition: border 0.2s;
}
input[type="number"]:focus {
  border: 1.5px solid #2563eb;
  outline: none;
}
.save-btn {
  padding: 7px 22px;
  background: #2563eb;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 10px;
}
.save-btn:hover {
  background: #1746a2;
}
.saved-msg {
  color: #27ae60;
  text-align: center;
  margin-top: 10px;
  font-size: 13px;
}
@media (max-width: 600px) {
  .khata-card {
    max-width: 98vw;
    padding: 8px 2vw 18px 2vw;
  }
  .khata-grid {
    grid-template-columns: 1fr;
  }
}
</style>